import React, { useState, useEffect } from 'react';
import { Switch, Route, Router, Redirect, useLocation } from 'react-router-dom';
import config from './config/apiConfig.js'
import Login from './Components/Auth/Login';
import Menu from './Components/Layout/Menu.js';
import HomeProductos from './Components/Productos/HomeProductos';
import NotFound from './Components/Generales/NotFound';
import ConfigHome from './Components/config/ConfigHome';
import ReportesHome from './Components/Reportes/ReportesHome';
import ReporteProductosRentabilidad from './Components/Reportes/ReporteProductosRentabilidad';
import Restringido from './Components/Generales/Restringido';
import ConfiguracionParametros from './Components/config/ConfiguracionParametros.js';
import Perfil from './Components/config/Perfil';
import TPV from './Components/TPV/TPV.js';
import ListaPerfiles from './Components/config/ListaPerfiles';
import ReporteOperacionVendedor from './Components/Reportes/ReporteOperacionVendedor';
import RecuperaPassword from './Components/Usuarios/RecuperaPassword';
import ReporteStock from './Components/Reportes/ReporteStock.js';
import PublicRoute from './Components/Util/PublicRoute';
import PrivateRoute from './Components/Util/PrivateRoute';
import Caduca from './Components/Generales/Caduca';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import ModalSucursales from './Components/ModalSucursales';
import ReporteRanking from './Components/Reportes/ReporteRanking.js';
import ReporteVariantes from './Components/Reportes/ReporteVariantes.js';
import ConfiguracionDTE from './Components/config/ConfiguracionDTE';
import ConfiguracionTurnos from './Components/config/ConfiguracionTurnos';
import ConfiguracionCajas from './Components/config/ConfiguracionCajas';
import configuracionSII from './Components/config/ConfiguracionSII';
// import SucursalesHome from './Components/Configuracion/SucursalesHome'; // oculto por ahora
import KitchenDisplay from './Components/Tienda/KitchenDisplay';
import AdministradorCategorias from './Components/Admin/AdministradorCategorias.js';
import KDS from './Components/Pedidos/KDS.js';
import AdministradorPedidos from './Components/Pedidos/AdministradorPedidos.js';
import AdministradorPlataformas from './Components/Admin/AdministradorPlataformas.js';
import IdleTimer from 'react-idle-timer';
import history from './history';
import './App.css';
import ConfiguracionSKUS from './Components/config/ConfiguracionSKUS';
import Help from './Components/Chatbot/Help';
import Terminos from './Components/Legal/Terminos';
import Privacidad from './Components/Legal/Privacidad';
import ConfirmarEntrega from './Components/Delivery/ConfirmarEntrega';
import { usarEstadoSuscripcion } from './services/clientesAppServicio';
import Home from './Components/Home/Home';
import InicioMenuQR from './Components/Home/InicioMenuQR';
import AdministradorProductos from './Components/Admin/AdministradorProductos.js';
import ConfiguradorTienda from './Components/Admin/ConfiguradorTienda.js';
import ConfiguradorPedidosWeb from './Components/Admin/ConfiguradorPedidosWeb.js';
import MenuBoard from './Components/DisplayPrecios/MenuBoard.js';
import ReporteCuadratura from './Components/Reportes/ReporteCuadratura';
import VentasHome from './Components/Ventas/VentasHome.js';
import ReporteProductos from './Components/Reportes/ReporteProductos.js';
import ListadoPedidos from './Components/Reportes/ListadoPedidos.js';
import AdministradorDespachos from './Components/Admin/AdministradorDespachos.js';
import AdministradorMetodosPago from './Components/Admin/AdministradorMetodosPago.js';
import MantenedorStaff from './Components/staff/MantenedorStaff.js';
import AdministradorImpresoras from './Components/Admin/AdministradorImpresoras.js';
import AdminRepartidores from './Components/Admin/AdminRepartidores.js';
import PedidosMesaForm from './Components/Pedidos/CatalogoMesas.js';
import PedidosMesa from './Components/Pedidos/PedidosMesa.js';
import AdministradorOfertas from './Components/Admin/AdministradorOfertas.js';
import ReporteHistorico from './Components/Reportes/ReporteHistorico.js';

import AdministradorMesas from './Components/Admin/AdministradorMesas.js'
import AdministradorNegocio from './Components/Admin/AdministradorNegocio.js';
import GestionInventario from './Components/Inventarios/GestionInventario.js';
import HomeInventario from './Components/Inventarios/HomeInventario.js';
import Insumos from './Components/Inventarios/Insumos.js';
import Proveedores from './Components/Inventarios/Proveedores.js';
import RecepcionCompras from './Components/Inventarios/RecepcionCompras.js';
import Pedidos from './Components/PedidosWeb/Pedidos.js';
import ImportarCarta from './Components/Admin/ImportarCarta.js';
import MantenedorClubClientes from './Components/Admin/MantenedorClubClientes.js';
import MantenedorGrupos from './Components/Admin/MantenedorGrupos.js';
import { AlertProvider } from './Components/context/AlertContext';
import { LicenciaProvider, useLicencia } from './Components/context/LicenciaContext';
import { PlanProvider, usePlan } from './Components/context/PlanContext';
import { IdiomaProvider } from './context/IdiomaContext';
import ModalLicencia from './Components/Auth/ModalLicencia';
import PantallaBloqueo from './PantallaBloqueo';

import AdminLogin from './Components/Auth/AdminLogin.js';
import LandingPage from './LandingPage';
import SuperAdminApp from './Components/SuperAdmin/SuperAdminApp';

// 🚩 COMPONENTE INTERNO QUE USA EL CONTEXTO DE LICENCIA
function AppContent() {
  const { verificarLicencia, iniciarPolling, estado: estadoLicencia, diasGracia } = useLicencia();
  const IS_WEB_MODE = true;

  // ESTADO DEL NEGOCIO
  const [negocioId, setNegocioId] = useState(localStorage.getItem('negocioId') || null);


  const handleBusinessLinked = (id) => {
    localStorage.setItem('negocioId', id);
    setNegocioId(id);
    history.push('/login');
  };

  // RESTO DE ESTADOS
  const [usuario, setUsuario] = useState(() => {
    const guardado = JSON.parse(localStorage.getItem('usuario') || '{}');
    // Si el usuario tiene rol, usarlo. Si no, intentar recuperarlo del JWT.
    if (guardado && guardado.rol) return guardado;
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const recuperado = { nombre: guardado.nombre || '', rol: payload.rol || 'ADMIN' };
        localStorage.setItem('usuario', JSON.stringify(recuperado));
        return recuperado;
      } catch (_) {}
    }
    return guardado || {};
  });
  const [sucursal, setSucursal] = useState(JSON.parse(localStorage.getItem('sucursal')) || {});
  const [sucursalesUsuario, setSucursalesUsuario] = useState(JSON.parse(localStorage.getItem('sucursales')) || []);
  const [modalSucursalAbierto, setModalBuscadorAbierto] = useState(false);
  const [authTokens, setAuthTokens] = useState(localStorage.getItem('token') || '');
  const [tiemposesion, setTiempoSesion] = useState(20);
  const [menuActivo, setMenuActivo] = useState(true);
  const [mostrarPopup, setMostrarPopup] = useState(false);

  // 🚩 ESTADOS PARA MODAL DE INACTIVIDAD
  const [modalInactividadAbierto, setModalInactividadAbierto] = useState(false);
  const [segundosRestantes, setSegundosRestantes] = useState(30);
  const idleTimerRef = React.useRef(null);
  const earlyWarningTimerRef = React.useRef(null);
  const [mostrarAvisoSesion, setMostrarAvisoSesion] = useState(false);

  const { estado } = usarEstadoSuscripcion();

  useEffect(() => {
    if (estado === 'expired2') setMostrarPopup(true);
  }, [estado]);

  // 🚩 Modal de inactividad: cuenta regresiva
  useEffect(() => {
    let intervalo;
    if (modalInactividadAbierto) {
      setSegundosRestantes(30);
      intervalo = setInterval(() => {
        setSegundosRestantes(prev => {
          if (prev <= 1) {
            clearInterval(intervalo);
            ejecutarCierreSesion();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(intervalo);
  }, [modalInactividadAbierto]);

  const reiniciarSesion = () => {
    if (idleTimerRef.current) idleTimerRef.current.reset();
    if (earlyWarningTimerRef.current) earlyWarningTimerRef.current.reset();
    setModalInactividadAbierto(false);
    setMostrarAvisoSesion(false);
  };

  const onEarlyIdle = () => {
    const esRutaPublica = window.location.pathname.startsWith('/cli/')
      || window.location.pathname.startsWith('/display/')
      || window.location.pathname.startsWith('/pedidos/mesas');
    if (esRutaPublica) return;
    setMostrarAvisoSesion(true);
    setTimeout(() => setMostrarAvisoSesion(false), 30000);
  };

  const ejecutarCierreSesion = () => {
    // 🚩 El destino depende de si el NEGOCIO tiene staff configurado, no del
    // rol del último usuario logueado: un dueño puede entrar por PIN con rol
    // "Administrador" en un negocio con staff, y ese negocio siempre usa
    // /login (PIN), nunca /adminlogin (email+clave).
    const negocioTieneStaff = localStorage.getItem('tieneStaff') === 'true';
    setModalInactividadAbierto(false);
    setAuthTokens('');
    setUsuario({});
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('sucursal');
    localStorage.removeItem('sucursales');
    // 🚩 Limpiar body para que caduca no herede padding ni clases del KDS/TPV
    document.body.classList.remove('menu-visible', 'fullscreen-mode');
    document.body.style.paddingLeft = '';
    document.body.style.paddingTop = '';
    history.push(negocioTieneStaff ? '/caduca/' : '/adminlogin');
  };

  const onIdle = () => {
    const esRutaPublica = window.location.pathname.startsWith('/cli/')
      || window.location.pathname.startsWith('/display/')
      || window.location.pathname.startsWith('/pedidos/mesas');
    if (esRutaPublica) return;
    setModalInactividadAbierto(true);
  };

  const setLogin = (data) => {
    localStorage.setItem('token', data.token);
    setAuthTokens(data.token);
    let usuario = data.usuario;
    localStorage.setItem('usuario', JSON.stringify(usuario));
    setUsuario(usuario);
    if (data.config !== null) {
      let configuracion = data.config;
      let sesion = configuracion.filter((elemento) => elemento.parametroCodigo === 'SES')[0].valor;
      setTiempoSesion(sesion);
    }
    // 🚩 PlanProvider solo carga el plan una vez al montar la app (cuando
    // todavía no hay token). Sin esto, el menú se queda con el plan por
    // defecto hasta que se recargue la página a mano.
    if (typeof cargarPlan === 'function') {
      cargarPlan();
    }
    // Verificar licencia al hacer login y arrancar polling cada 5 min
    setTimeout(() => {
      if (typeof verificarLicencia === 'function') {
        verificarLicencia();
        iniciarPolling();
      }
    }, 500);
  };

  const cierreSesion = () => {
    // 🚩 El destino depende de si el NEGOCIO tiene staff configurado, no del
    // rol del último usuario logueado: un dueño puede entrar por PIN con rol
    // "Administrador" en un negocio con staff, y ese negocio siempre usa
    // /login (PIN), nunca /adminlogin (email+clave). Solo los negocios SIN
    // staff (bypass de admin-login) vuelven a /adminlogin.
    const negocioTieneStaff = localStorage.getItem('tieneStaff') === 'true';
    setModalInactividadAbierto(false);
    setAuthTokens('');
    setUsuario({});
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    // 🚩 Limpiar body para que el login no herede padding ni clases del KDS/TPV
    document.body.classList.remove('menu-visible', 'fullscreen-mode');
    document.body.style.paddingLeft = '';
    document.body.style.paddingTop = '';
    history.push(negocioTieneStaff ? '/login' : '/adminlogin');
  };

  const closeModal = () => setModalBuscadorAbierto(false);

  const esAdmin = usuario && usuario.rol && (
    usuario.rol.toUpperCase() === 'ADMIN' || usuario.rol.toUpperCase() === 'ADMINISTRADOR'
  );

  const { plan, tienePOS, tienePedidosWeb, tieneMesas, tienePedidosMesa, cargarPlan } = usePlan();

  // =====================================================================
  // ⛔ 1. SUPER ADMIN
  // =====================================================================
  if (window.location.pathname.startsWith('/bimba')) {
    return (
      <AlertProvider>
        <Router history={history}>
          <Route path="/bimba">
            <SuperAdminApp />
          </Route>
        </Router>
      </AlertProvider>
    );
  }

  // =====================================================================
  // ⛔ 2. DISPOSITIVOS NO VINCULADOS
  // =====================================================================
  if (IS_WEB_MODE && !negocioId) {
    return (
      <AlertProvider>
        <Router history={history}>
          <Switch>
            <Route path="/qr/:slug" component={Pedidos} />
            <Route path="/cli/:slug" component={Pedidos} />
            <Route path="/negocio/:slug" component={Pedidos} />
            <Route path="/display/:slug" component={MenuBoard} />
            <Route path="/carta/importar/:slug?" component={ImportarCarta} />
            <Route path="/terminos" component={Terminos} />
            <Route path="/privacidad" component={Privacidad} />
            <Route path="/pedido/entregado/:token" component={ConfirmarEntrega} />
            <Route path="/adminlogin" exact>
              <AdminLogin onBusinessLinked={handleBusinessLinked} setLogin={setLogin} setNegocioId={setNegocioId} />
            </Route>
            <Route path="/login" exact>
              <Login setLogin={setLogin} />
            </Route>
            <Route path="/" exact>
              <LandingPage />
            </Route>
            <Route path="/:slug" exact component={Pedidos} />
            <Route path="/">
              <LandingPage />
            </Route>
          </Switch>
        </Router>
      </AlertProvider>
    );
  }

  // =====================================================================
  // ✅ 3. APP PRINCIPAL
  // =====================================================================
  return (
    <AlertProvider>
      <div className="App">
        <div style={{ paddingTop: '0' }}>
          {mostrarPopup && (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
              <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', textAlign: 'center' }}>
                <h2>¡Tu suscripción ha expirado!</h2>
                <button onClick={() => { setMostrarPopup(false); history.push('/planes/'); }} style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#009ee3', color: 'white', border: 'none' }}>Ver Planes</button>
              </div>
            </div>
          )}

          <Modal open={modalSucursalAbierto} showCloseIcon={false} center>
            <ModalSucursales sucursales={sucursalesUsuario} sucursal={sucursal} seleccionaSucursal={(s) => { localStorage.setItem('sucursal', JSON.stringify(s)); setSucursal(s); window.location.reload(true); }} closeModal={closeModal} />
          </Modal>

          {/* 🚩 MODAL DE INACTIVIDAD */}
          {modalInactividadAbierto && (
            <div style={{
              position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
              backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 9999,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              backdropFilter: 'blur(5px)'
            }} onClick={reiniciarSesion}>
              <div style={{
                backgroundColor: 'white', borderRadius: '20px', padding: '40px',
                maxWidth: '420px', width: '90%', textAlign: 'center',
                boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
              }} onClick={(e) => e.stopPropagation()}>
                <div style={{ fontSize: '3rem', marginBottom: '15px' }}>⏰</div>
                <h3 style={{ fontWeight: 700, marginBottom: '8px', color: '#1a1c1d' }}>¿Sigues ahí?</h3>
                <p style={{ color: '#64748b', marginBottom: '20px', fontSize: '0.95rem' }}>
                  Tu sesión está por expirar por inactividad.
                </p>
                <div style={{
                  fontSize: '3rem', fontWeight: 900, color: segundosRestantes <= 10 ? '#dc2626' : '#f26b21',
                  marginBottom: '25px'
                }}>
                  {segundosRestantes}
                  <span style={{ fontSize: '1rem', fontWeight: 400, color: '#94a3b8' }}> seg</span>
                </div>
                <button
                  style={{
                    width: '100%', padding: '14px', fontSize: '1.1rem', fontWeight: 700,
                    backgroundColor: '#f26b21', color: 'white', border: 'none', borderRadius: '14px',
                    cursor: 'pointer', boxShadow: '0 4px 15px rgba(242,107,33,0.35)',
                    transition: 'all 0.2s'
                  }}
                  onClick={reiniciarSesion}
                >
                  👋 SEGUIR AQUÍ
                </button>
                <button
                  style={{
                    marginTop: '12px', background: 'none', border: 'none',
                    color: '#94a3b8', fontWeight: 600, cursor: 'pointer',
                    padding: '10px', fontSize: '0.85rem'
                  }}
                  onClick={ejecutarCierreSesion}
                >
                  CERRAR SESIÓN AHORA
                </button>
              </div>
            </div>
          )}

          {/* Aviso temprano: 2 minutos antes del timeout */}
          {mostrarAvisoSesion && !modalInactividadAbierto && (
            <div
              onClick={reiniciarSesion}
              style={{
                position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
                background: '#1a1a2e', color: '#fff', borderRadius: '12px',
                padding: '12px 20px', zIndex: 9998, cursor: 'pointer',
                boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
                display: 'flex', alignItems: 'center', gap: '10px',
                fontSize: '0.9rem', fontWeight: 600, whiteSpace: 'nowrap'
              }}
            >
              <span>⏱️ Tu sesión cerrará pronto por inactividad.</span>
              <span style={{ background: '#f26b21', padding: '4px 12px', borderRadius: '8px', fontSize: '0.8rem' }}>Continuar</span>
            </div>
          )}

          <IdleTimer
            ref={earlyWarningTimerRef}
            element={document}
            onIdle={onEarlyIdle}
            debounce={250}
            timeout={1000 * 60 * Math.max(tiemposesion - 2, 1)}
          />
          <IdleTimer
            ref={idleTimerRef}
            element={document}
            onIdle={onIdle}
            debounce={250}
            timeout={1000 * 60 * tiemposesion}
          />

          {/* 🚩 MODAL DE LICENCIA (solo WARNING) */}
          <ModalLicencia />

          {/* 🚩 OVERLAY DE BLOQUEO — aparece post-login si el negocio está bloqueado por morosidad */}
          {authTokens && estadoLicencia === 'BLOQUEO' && (
            <PantallaBloqueo diasGracia={diasGracia} />
          )}

          <Router history={history}>
            <AppInterno
              usuario={usuario}
              authTokens={authTokens}
              menuActivo={menuActivo}
              cierreSesion={cierreSesion}
              abrirMenuSucursales={() => setModalBuscadorAbierto(true)}
              onCambiarPDV={() => { localStorage.removeItem('terminalNombre'); cierreSesion(); }}
            >
              <Switch>
                <Route path="/adminlogin" exact>
                  {authTokens
                    ? <Redirect to="/login" />
                    : <AdminLogin onBusinessLinked={handleBusinessLinked} setLogin={setLogin} setNegocioId={setNegocioId} />
                  }
                </Route>
                <Route path="/qr/:slug" component={Pedidos} />
                <Route path="/cli/:slug" component={Pedidos} />
                <Route path="/negocio/:slug" component={Pedidos} />
                <Route path="/display/:slug" component={MenuBoard} />
                <Route path="/pedido/entregado/:token" component={ConfirmarEntrega} />
                <Route path="/login" exact>
                  <Login setLogin={setLogin} setEligeSucursal={(s) => { localStorage.setItem('sucursal', JSON.stringify(s)); setSucursal(s); }} setSucursalesUsuario={setSucursalesUsuario} AbrirMenuSucursales={() => setModalBuscadorAbierto(true)} />
                </Route>
                <PrivateRoute path="/home/" component={
                    usuario.rol === 'COCINA' ? KDS :
                    plan === 'MENU_QR' ? InicioMenuQR :
                    Home
                } exact />
                <PrivateRoute path="/" component={Home} exact />
                <PrivateRoute exact path="/ventas/pos/" component={tienePOS ? TPV : Restringido} />
                <PrivateRoute exact path="/productos/home/" component={HomeProductos} />
                <PrivateRoute exact path="/productos/" component={esAdmin ? AdministradorProductos : Restringido} />
                <PrivateRoute exact path="/categorias/" component={AdministradorCategorias} />
                <PublicRoute exact path="/ventas/tpv" component={(esAdmin || usuario.rol === 'OPERADOR') && tienePOS ? TPV : Restringido} />
                <PublicRoute exact path="/ventas/home" component={tienePOS ? VentasHome : Restringido} />
                <PrivateRoute exact path="/configuracion/home/" component={esAdmin ? ConfigHome : Restringido} />
                <PrivateRoute exact path="/configuracion/parametros/" component={esAdmin ? ConfiguracionParametros : Restringido} />
                <PrivateRoute exact path="/configuracion/perfil/" component={Perfil} />
                <PrivateRoute exact path="/configuracion/perfiles/" component={ListaPerfiles} />
                <PrivateRoute exact path="/configuracion/dte/" component={ConfiguracionDTE} />
                <PrivateRoute exact path="/configuracion/turnos/" component={ConfiguracionTurnos} />
                <PrivateRoute exact path="/configuracion/cajas/" component={ConfiguracionCajas} />
                <PrivateRoute exact path="/configuracion/sii/" component={configuracionSII} />
                <PrivateRoute exact path="/configuracion/tienda/" component={ConfiguradorTienda} />
                <PrivateRoute exact path="/configuracion/pedidos-web/" component={ConfiguradorPedidosWeb} />
                {/* Sucursales: oculto por ahora, se retoma en el futuro (multi-sucursal no está listo) */}
                {/* <PrivateRoute exact path="/configuracion/sucursales/" component={SucursalesHome} /> */}
                <PrivateRoute exact path="/configuracion/skus/" component={ConfiguracionSKUS} />
                <PrivateRoute exact path="/staff/" component={MantenedorStaff} />
                <PrivateRoute exact path="/fidelizacion/clientes/" component={(esAdmin || (usuario && usuario.rol === 'DUENO')) ? MantenedorClubClientes : Restringido} />
                <PrivateRoute exact path="/admin/impresoras" component={tienePOS ? AdministradorImpresoras : Restringido} />
                <PrivateRoute exact path="/admin/repartidores/" component={AdminRepartidores} />
                <PrivateRoute exact path="/pedidos/" component={AdministradorPedidos} />
                <PrivateRoute exact path="/admin/despachos/" component={plan !== 'MENU_QR' ? AdministradorDespachos : Restringido} />
                <PrivateRoute exact path="/admin/metodos-pago/" component={AdministradorMetodosPago} />
                <PrivateRoute exact path="/admin/plataformas/" component={tienePedidosWeb ? AdministradorPlataformas : Restringido} />
                <PrivateRoute exact path="/reporte/cuadratura/" component={ReporteCuadratura} />
                <PrivateRoute exact path="/pedidos/mesas/form" component={tieneMesas ? PedidosMesaForm : Restringido} />
                <PrivateRoute exact path="/mesas/" component={tieneMesas ? PedidosMesa : Restringido} />
                <PrivateRoute exact path="/admin/inventario/" component={HomeInventario} />
                <PrivateRoute exact path="/admin/inventario/stock" component={GestionInventario} />
                <PrivateRoute exact path="/admin/inventario/insumos" component={Insumos} />
                <PrivateRoute exact path="/admin/inventario/proveedores" component={Proveedores} />
                <PrivateRoute exact path="/admin/inventario/recepcion" component={RecepcionCompras} />
                <PrivateRoute exact path="/kds/" component={KDS} />
                <PrivateRoute exact path="/admin/ofertas/" component={AdministradorOfertas} />
                <PrivateRoute exact path="/admin/estilos/">
                  <Redirect to="/configuracion/tienda/" />
                </PrivateRoute>
                <PrivateRoute exact path="/admin/estilos-tienda/">
                  <Redirect to="/configuracion/tienda/" />
                </PrivateRoute>
                <PrivateRoute exact path="/admin/mesas/" component={tieneMesas ? AdministradorMesas : Restringido} />
                <PrivateRoute exact path="/admin/negocio/" component={AdministradorNegocio} />
                <PrivateRoute exact path="/productos/grupos/" component={MantenedorGrupos} />
                <PrivateRoute exact path="/reportes/home/" component={esAdmin ? ReportesHome : Restringido} />
                <PrivateRoute exact path="/reportes/productos/rentabilidad/" component={ReporteProductosRentabilidad} />
                <PrivateRoute exact path="/reportes/vendedor/" component={ReporteOperacionVendedor} />
                <PrivateRoute exact path="/reportes/stock/" component={ReporteStock} />
                <PrivateRoute exact path="/reportes/ranking/" component={ReporteRanking} />
                <PrivateRoute exact path="/reportes/producto/" component={ReporteProductos} />
                <PrivateRoute exact path="/reportes/listado-pedidos/" component={ListadoPedidos} />
                <PrivateRoute exact path="/reportes/historico/" component={ReporteHistorico} />
                <PrivateRoute exact path="/reportes/variantes/" component={ReporteVariantes} />
                <PublicRoute path="/restringido/" component={Restringido} exact />
                <PublicRoute path="/kitchen/" component={KitchenDisplay} />
                <PublicRoute path="/usuario/recupera/" component={RecuperaPassword} exact />
                <PublicRoute path="/caduca/" component={Caduca} exact />
                <Route path="/carta/importar/:slug?" component={ImportarCarta} />
                <Route path="/help/" component={Help} />
                <Route path="/terminos" component={Terminos} />
                <Route path="/privacidad" component={Privacidad} />
                <Route path="/:slug" exact component={Pedidos} />
                <Route component={NotFound} />
              </Switch>
            </AppInterno>
          </Router>
        </div>
      </div>
    </AlertProvider>
  );
}

// 🚩 Componente interno
function AppInterno({ usuario, sucursal, authTokens, menuActivo, cierreSesion, abrirMenuSucursales, onCambiarPDV, children }) {
  const location = useLocation();
  const rutasSinMenu = ['/ventas/pos/', '/kds/', '/pedidos/mesas/form', '/kitchen/', '/display/', '/login', '/carta/importar'];
  const pathActual = location.pathname;
  const mostrarMenu = authTokens && menuActivo && !rutasSinMenu.some(r => pathActual.startsWith(r));
  const esRutaFullScreen = rutasSinMenu.some(r => pathActual.startsWith(r));

  useEffect(() => {
    if (mostrarMenu) {
      document.body.classList.add('menu-visible');
    } else {
      document.body.classList.remove('menu-visible');
    }
    if (esRutaFullScreen) {
      document.body.classList.add('fullscreen-mode');
    } else {
      document.body.classList.remove('fullscreen-mode');
    }
  }, [mostrarMenu, esRutaFullScreen]);

  return (
    <>
      <div>
        {mostrarMenu ? (
          <Menu usuario={usuario} sucursal={sucursal} abrirMenuSucursales={abrirMenuSucursales} cierreSesion={cierreSesion} onCambiarPDV={onCambiarPDV} />
        ) : ''}
      </div>
      <div className="row" style={{margin:0, padding:0}}>
        <div className="col-md-12" style={{padding:0, margin:0}}>
          <div className={`contenedorPrincipal ${mostrarMenu ? 'espacio-para-menu' : ''}`}>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}

export default function App() {
  return (
    <IdiomaProvider>
      <LicenciaProvider>
        <PlanProvider>
          <AppContent />
        </PlanProvider>
      </LicenciaProvider>
    </IdiomaProvider>
  );
}